/**
 * React Query wrapper for the announcement feed. Never refetches on window focus —
 * the modal is a cold-app-open surface, not something to re-pop when the tab regains
 * focus. See specs/in-app-announcements/spec.md.
 */

import { useQuery } from '@tanstack/react-query';
import { fetchAnnouncements } from '../api/announcementsApi';
import {
  ANNOUNCEMENT_QUERY_STALE_MS,
  ANNOUNCEMENT_QUERY_GC_MS,
} from '../constants/announcements.constants';

export const ANNOUNCEMENTS_QUERY_KEY = ['app-config', 'announcements'] as const;

export function useAnnouncementsQuery(enabled: boolean) {
  return useQuery({
    queryKey: ANNOUNCEMENTS_QUERY_KEY,
    queryFn: fetchAnnouncements,
    enabled,
    staleTime: ANNOUNCEMENT_QUERY_STALE_MS,
    gcTime: ANNOUNCEMENT_QUERY_GC_MS,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
